import { SERVICES } from 'tenant/config';

const sendEventToSegment = async (event, params = {}) => {
  if (!SERVICES.SEGMENT) return null;
  if (!window.analytics || !window.analytics.track) {
    console.warn(`[Segment] Not sending event ${event}`, params);
    return;
  }
  try {
    window.analytics.track(event, params);
  } catch (e) {
    console.error('Error while sending event to segment: ', e);
  }
};

export default sendEventToSegment;
